import { ScopeConfigurationState } from '../model/scope-configuration/scope-configuration.state.model'

const initialLoadingState = { saveConfiguration: false, submitConfiguration: false, getModifiers: false }

export const scopeConfigurationInitialState: ScopeConfigurationState = {
  loading: initialLoadingState,
  modifiers: [],
  configuration: {},
}
